export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700-24b17813218faea2b2565b183ac86676.ttf";